import React, { FunctionComponent } from 'react';
import { HeadProvider, Style } from 'react-head';
import { useAppSelector } from 'state/hooks';

const Layout: FunctionComponent<React.PropsWithChildren> = ({ children }) => {
    const brandStyles = useAppSelector((s) => s.site.brandStyles);
    return (
        <>
            <HeadProvider>
                <Style>{brandStyles}</Style>
            </HeadProvider>
            {children}
        </>
    );
};

export default Layout;
